<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="90%"
    title="Thêm mới học sinh"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    custom-class="sk-dialog"
    top="3vh"
  >
    <el-form
      :model="formAllTabStudent"
      :rules="rules"
      label-width="130px"
      label-position="left"
      ref="formAllTabStudent"
    >
      <el-tabs type="card" @tab-click="handleClickTab" v-model="activeTabName">
        <el-tab-pane label="Thông tin" name="mainInfo">
          <div class="common-info-tab">
            <el-row :gutter="24">
              <!-- Column 1: Profile Summary & status -->
              <el-col :span="6">
                <div class="profile-sidebar-card">
                  <!-- Avatar Area -->
                  <div class="profile-avatar-wrap">
                    <el-image
                        v-if="imageUrlPreview"
                        class="profile-avatar"
                        :src="imageUrlPreview"
                        fit="cover"
                    ></el-image>
                    
                    <!-- Hidden upload trigger -->
                    <el-upload
                        :show-file-list="false"
                        :on-change="handleChangeUpload"
                        :on-remove="handleRemove"
                        :auto-upload="false"
                        style="display: none;"
                        ref="upload"
                        action=""
                    >
                    </el-upload>
                    
                    <!-- Click-to-add Area if empty -->
                    <div 
                        v-if="!imageUrlPreview"
                        class="avatar-trigger-area"
                        @click="triggerAvatarUpload"
                    >
                      <i class="el-icon-plus"></i>
                      <span>Thêm ảnh</span>
                    </div>
                    
                    <!-- Hover edit/delete overlay if image exists -->
                    <div 
                        v-else
                        class="avatar-actions-overlay"
                    >
                      <button type="button" class="avatar-action-btn edit-btn" @click="triggerAvatarUpload" title="Thay đổi ảnh">
                        <i class="el-icon-edit-outline"></i>
                      </button>
                      <button type="button" class="avatar-action-btn delete-btn" @click="handleRemove" title="Xóa ảnh">
                        <i class="el-icon-delete"></i>
                      </button>
                    </div>
                  </div>

                  <!-- Status Area -->
                  <div class="profile-status-section">
                    <div class="section-divider">Trạng thái học tập</div>
                    <el-radio-group
                        v-model="formAllTabStudent.kidMainInfo.kidStatus"
                        class="status-radio-group"
                    >
                      <el-radio-button label="STUDYING">Đang học</el-radio-button>
                      <el-radio-button label="STUDY_WAIT">Chờ học</el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
              </el-col>

              <!-- Column 2: Student Information Grid -->
              <el-col :span="9">
                <div class="info-section-card">
                  <div class="card-inner-title"><i class="el-icon-user"></i> Thông tin học sinh</div>
                  
                  <el-row :gutter="16">
                    <el-col :span="12">
                      <el-form-item label="Chọn khối học" prop="kidMainInfo.idGrade">
                        <el-select
                            v-model="formAllTabStudent.kidMainInfo.idGrade"
                            filterable
                            @change="selectGradeMethod()"
                            placeholder="Chọn khối học"
                            style="width: 100%"
                        >
                          <el-option
                              v-for="item in gradeOfSchoolList"
                              :key="item.id"
                              :value="item.id"
                              :label="item.gradeName"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="Chọn lớp học" prop="kidMainInfo.idClass">
                        <el-select
                            v-model="formAllTabStudent.kidMainInfo.idClass"
                            filterable
                            clearable
                            placeholder="Chọn lớp học"
                            style="width: 100%"
                        >
                          <el-option
                              v-for="item in classOfGradeList"
                              :key="item.id"
                              :value="item.id"
                              :label="item.className"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="16">
                    <el-col :span="12">
                      <el-form-item label="Họ tên" prop="kidMainInfo.fullName">
                        <el-input clearable v-model="formAllTabStudent.kidMainInfo.fullName"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="Biệt danh" prop="kidMainInfo.nickName">
                        <el-input clearable v-model="formAllTabStudent.kidMainInfo.nickName"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="16">
                    <el-col :span="12">
                      <el-form-item label="Người đại diện" prop="kidMainInfo.representation">
                        <el-radio-group v-model="formAllTabStudent.kidMainInfo.representation" class="gender-radio-group">
                          <el-tooltip
                              effect="dark"
                              content="Số điện thoại người đại diện là tài khoản ứng dụng OneKids và nhận tin nhắn SMS từ nhà trường"
                              placement="top"
                          >
                            <el-radio-button label="Bố">Bố</el-radio-button>
                          </el-tooltip>
                          <el-tooltip
                              effect="dark"
                              content="Số điện thoại người đại diện là tài khoản ứng dụng OneKids và nhận tin nhắn SMS từ nhà trường"
                              placement="top"
                          >
                            <el-radio-button label="Mẹ">Mẹ</el-radio-button>
                          </el-tooltip>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="Giới tính" prop="kidMainInfo.gender">
                        <el-radio-group v-model="formAllTabStudent.kidMainInfo.gender" class="gender-radio-group">
                          <el-radio-button label="Nam">Nam</el-radio-button>
                          <el-radio-button label="Nữ">Nữ</el-radio-button>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="16">
                    <el-col :span="12">
                      <el-form-item label="Ngày sinh" prop="kidMainInfo.birthDay">
                        <el-date-picker
                            clearable
                            v-model="formAllTabStudent.kidMainInfo.birthDay"
                            format="dd-MM-yyyy"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="Chọn ngày sinh"
                            style="width: 100%"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="Dân tộc" prop="kidMainInfo.ethnic">
                        <el-input clearable v-model="formAllTabStudent.kidMainInfo.ethnic"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="16">
                    <el-col :span="12">
                      <el-form-item label="Địa chỉ hiện tại" prop="kidMainInfo.address">
                        <el-input clearable v-model="formAllTabStudent.kidMainInfo.address"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="Địa chỉ thường trú" prop="kidMainInfo.permanentAddress">
                        <el-input clearable v-model="formAllTabStudent.kidMainInfo.permanentAddress"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="16">
                    <el-col :span="12">
                      <el-form-item label="Quốc tịch" prop="kidMainInfo.national">
                        <el-input clearable v-model="formAllTabStudent.kidMainInfo.national"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="Ngày nhập học" prop="kidMainInfo.dateStart">
                        <el-date-picker
                            clearable
                            v-model="formAllTabStudent.kidMainInfo.dateStart"
                            format="dd-MM-yyyy"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="Chọn ngày học"
                            style="width: 100%"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-form-item label="Số định danh" prop="kidMainInfo.identificationNumber">
                    <span slot="label">
                      Số định danh
                      <el-tooltip class="item" effect="dark" content="Số định danh của học sinh" placement="top">
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </span>
                    <el-input clearable v-model="formAllTabStudent.kidMainInfo.identificationNumber"></el-input>
                  </el-form-item>

                  <el-form-item label="Ghi chú" prop="kidMainInfo.note">
                    <el-input
                        v-model="formAllTabStudent.kidMainInfo.note"
                        type="textarea"
                        :rows="2"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <!-- Column 3: Parent & Finance Details -->
              <el-col :span="9">
                <div class="column-parent-flex">
                  <!-- Father Card -->
                  <div class="info-section-card parent-card">
                    <div class="card-inner-title"><i class="el-icon-user"></i> Thông tin Bố</div>
                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Họ tên bố" prop="kidMainInfo.fatherName">
                          <el-input clearable v-model="formAllTabStudent.kidMainInfo.fatherName"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Số điện thoại" prop="kidMainInfo.fatherPhone">
                          <el-input clearable v-model="formAllTabStudent.kidMainInfo.fatherPhone"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    
                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Ngày sinh" prop="kidMainInfo.fatherBirthday">
                          <el-date-picker
                              clearable
                              v-model="formAllTabStudent.kidMainInfo.fatherBirthday"
                              format="dd-MM-yyyy"
                              :picker-options="pickerOptions"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="Chọn ngày"
                              style="width: 100%"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Email bố" prop="kidMainInfo.fatherEmail">
                          <el-input clearable v-model="formAllTabStudent.kidMainInfo.fatherEmail"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Nghề nghiệp" prop="kidMainInfo.fatherJob">
                          <el-input clearable v-model="formAllTabStudent.kidMainInfo.fatherJob"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Số định danh" prop="kidMainInfo.fatherCitizenIdentification">
                          <span slot="label">
                            Số định danh
                            <el-tooltip class="item" effect="dark" content="Số định danh của học sinh" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </span>
                          <el-input clearable v-model="formAllTabStudent.kidMainInfo.fatherCitizenIdentification"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>

                  <!-- Mother Card -->
                  <div class="info-section-card parent-card">
                    <div class="card-inner-title"><i class="el-icon-user"></i> Thông tin Mẹ</div>
                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Họ tên mẹ" prop="kidMainInfo.motherName">
                          <el-input clearable v-model="formAllTabStudent.kidMainInfo.motherName"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Số điện thoại" prop="kidMainInfo.motherPhone">
                          <el-input clearable v-model="formAllTabStudent.kidMainInfo.motherPhone"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Ngày sinh" prop="kidMainInfo.motherBirthday">
                          <el-date-picker
                              clearable
                              v-model="formAllTabStudent.kidMainInfo.motherBirthday"
                              format="dd-MM-yyyy"
                              :picker-options="pickerOptions"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="Chọn ngày"
                              style="width: 100%"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Email mẹ" prop="kidMainInfo.motherEmail">
                          <el-input clearable v-model="formAllTabStudent.kidMainInfo.motherEmail"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Nghề nghiệp" prop="kidMainInfo.motherJob">
                          <el-input clearable v-model="formAllTabStudent.kidMainInfo.motherJob"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Số định danh" prop="kidMainInfo.motherCitizenIdentification">
                          <span slot="label">
                            Số định danh
                            <el-tooltip class="item" effect="dark" content="Số định danh của học sinh" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </span>
                          <el-input clearable v-model="formAllTabStudent.kidMainInfo.motherCitizenIdentification"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>

                  <!-- Finance Card -->
                  <div class="info-section-card parent-card">
                    <div class="card-inner-title"><i class="el-icon-wallet"></i> Tài khoản thu học phí</div>
                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Chủ tài khoản" prop="kidMainInfo.accountHolderStudent">
                          <el-input clearable v-model="formAllTabStudent.kidMainInfo.accountHolderStudent"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Tên ngân hàng" prop="kidMainInfo.bankNameStudent">
                          <el-input clearable v-model="formAllTabStudent.kidMainInfo.bankNameStudent"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Số tài khoản" prop="kidMainInfo.accountNumberStudent">
                          <el-input clearable v-model="formAllTabStudent.kidMainInfo.accountNumberStudent"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Mã số thuế" prop="kidMainInfo.taxIdentificationNumber">
                          <el-input clearable v-model="formAllTabStudent.kidMainInfo.taxIdentificationNumber"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>

        <!-- sức khỏe chung -->
        <el-tab-pane label="Sức khỏe chung" name="extraInfo">
          <el-col :span="15" style="margin-left: 20%">
            <el-form-item label="Nhóm máu" prop="kidsExtraInfo.bloodType">
              <el-input
                clearable
                v-model="formAllTabStudent.kidsExtraInfo.bloodType"
                placeholder="Nhập nhóm máu"
              ></el-input>
            </el-form-item>
            <el-form-item label="Bơi" prop="kidsExtraInfo.swim">
              <el-input
                clearable
                v-model="formAllTabStudent.kidsExtraInfo.swim"
                placeholder="Nhập bơi"
              ></el-input>
            </el-form-item>
            <el-form-item label="Dị ứng" prop="kidsExtraInfo.allery">
              <el-input
                clearable
                v-model="formAllTabStudent.kidsExtraInfo.allery"
                placeholder="Nhập dị ứng"
              ></el-input>
            </el-form-item>
            <el-form-item label="Ăn kiêng" prop="kidsExtraInfo.diet">
              <el-input
                clearable
                v-model="formAllTabStudent.kidsExtraInfo.diet"
                placeholder="Nhập ăn kiêng"
              ></el-input>
            </el-form-item>
            <el-form-item label="Tai" prop="kidsExtraInfo.ear">
              <el-input
                clearable
                v-model="formAllTabStudent.kidsExtraInfo.ear"
                placeholder="Nhập tai"
              ></el-input>
            </el-form-item>
            <el-form-item label="Mũi" prop="kidsExtraInfo.nose">
              <el-input
                clearable
                v-model="formAllTabStudent.kidsExtraInfo.nose"
                placeholder="Nhập mũi"
              ></el-input>
            </el-form-item>
            <el-form-item label="Họng" prop="kidsExtraInfo.throat">
              <el-input
                clearable
                v-model="formAllTabStudent.kidsExtraInfo.throat"
                placeholder="Nhập họng"
              ></el-input>
            </el-form-item>
            <el-form-item label="Da" prop="kidsExtraInfo.skin">
              <el-input
                clearable
                v-model="formAllTabStudent.kidsExtraInfo.skin"
                placeholder="Nhập da"
              ></el-input>
            </el-form-item>
            <el-form-item label="Mắt" prop="kidsExtraInfo.eyes">
              <el-input
                clearable
                v-model="formAllTabStudent.kidsExtraInfo.eyes"
                placeholder="Nhập mắt"
              ></el-input>
            </el-form-item>
            <el-form-item label="Tim" prop="kidsExtraInfo.heart">
              <el-input
                clearable
                v-model="formAllTabStudent.kidsExtraInfo.heart"
                placeholder="Nhập tim"
              ></el-input>
            </el-form-item>
            <el-form-item label="Béo phì" prop="kidsExtraInfo.fat">
              <el-input
                clearable
                v-model="formAllTabStudent.kidsExtraInfo.fat"
                placeholder="Nhập béo phì"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-tab-pane>

        <el-tab-pane label="App Onekids" name="parentIcon">
          <!-- table 1 -->
          <el-table
            class="table-icon-1"
            border
            :data="parentIconAppCreate.parentIconCreate1"
            highlight-current-row
            :header-cell-style="tableHeaderColor"
          >
            <el-table-column type="index"></el-table-column>
            <el-table-column prop="iconName" label="Chức năng"></el-table-column>
            <el-table-column label="Hiển thị" align="center">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.statusShow"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column label="Mở khóa" align="center">
              <template slot-scope="scope">
                <el-checkbox
                  v-if="scope.row.rootLockStatus"
                  v-model="scope.row.status"
                ></el-checkbox>
                <el-checkbox v-else disabled></el-checkbox>
              </template>
            </el-table-column>
          </el-table>

          <!-- table 2 -->
          <el-table
            class="table-icon-2"
            border
            :data="parentIconAppCreate.parentIconCreate2"
            highlight-current-row
            :header-cell-style="tableHeaderColor"
          >
            <el-table-column type="index"></el-table-column>
            <el-table-column prop="iconName" label="Chức năng"></el-table-column>
            <el-table-column label="Hiển thị" align="center">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.statusShow"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column label="Mở khóa" align="center">
              <template slot-scope="scope">
                <el-checkbox
                  v-if="scope.row.rootLockStatus"
                  v-model="scope.row.status"
                ></el-checkbox>
                <el-checkbox v-else disabled></el-checkbox>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-form>

    <div class="tab-infor-button sk-dialog-footer">
      <el-button
        class="btn-cancel"
        type="danger"
        size="medium"
        @click="closeDialogByButton('formAllTabStudent')"
      >
        <i class="el-icon-circle-close" />
        <span>Đóng</span>
      </el-button>
      <el-button
        class="btn-save"
        type="success"
        size="medium"
        :loading="loadingButton"
        mini
        @click="submitForm('formAllTabStudent')"
      >
        <i class="el-icon-circle-check" />
        <span>Lưu</span>
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import StudentService from "@/services/StudentService";
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  props: {
    dialogVisible: null,
  },
  data() {
    let checkDate = (rule, value, callback) => {
      if (value > new Date()) {
        callback(new Error("Ngày phải nhỏ hơn ngày hiện tại"));
      } else {
        callback();
      }
    };

    return {
      activeTabName: "mainInfo",
      newGrade: {
        gradeName: "",
        gradeDescription: "",
      },
      avatar: {},
      imageUrl: "",
      imageUrlPreview: "",
      showUpload: true,
      parentIconAppCreate: {
        parentIconCreate1: [],
        parentIconCreate2: [],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      formAllTabStudent: {
        kidMainInfo: {
          idGrade: "",
          idClass: "",
          kidStatus: "STUDYING",
          fullName: "",
          birthDay: "",
          gender: "",
          nickName: "",
          address: "",
          dateStart: "",
          note: "",
          representation: "",
          fatherName: "",
          fatherBirthday: "",
          fatherPhone: "",
          fatherEmail: "",
          fatherJob: "",
          motherName: "",
          motherBirthday: "",
          motherPhone: "",
          motherEmail: "",
          motherJob: "",
          identificationNumber: "",
          permanentAddress: "",
          ethnic: "",
          taxIdentificationNumber: "",
          accountHolderStudent: "",
          bankNameStudent: "",
          accountNumberStudent: "",
          fatherCitizenIdentification: "",
          motherCitizenIdentification: "",
        },
        kidsExtraInfo: {
          bloodType: "",
          swim: "",
          allery: "",
          diet: "",
          ear: "",
          nose: "",
          throat: "",
          eyes: "",
          skin: "",
          heart: "",
          fat: "",
          note: "",
        },
        parentIconApp: [],
      },
      value: "",

      newStudentCreated: null,
      loadingButton: false,
      rules: {
        kidMainInfo: {
          idGrade: [
            {
              required: true,
              message: "Khối không được để trống",
              trigger: "change",
            },
          ],

          idClass: [
            {
              required: true,
              message: "Lớp không được để trống",
              trigger: "change",
            },
          ],
          fullName: [
            {
              required: true,
              message: "Họ tên không được để trống",
              trigger: ["blur", "change"],
            },
          ],
          gender: [
            {
              required: true,
              message: "Giới tính không được để trống",
              trigger: "change",
            },
          ],
          birthDay: [
            {
              required: true,
              message: "Ngày sinh không được để trống",
              trigger: "change",
            },
            { validator: checkDate, trigger: "change" },
          ],
          dateStart: [
            {
              required: true,
              message: "Ngày nhập học không được để trống",
              trigger: "change",
            },
          ],

          fatherBirthday: [{ validator: checkDate, trigger: "change" }],
          motherBirthday: [{ validator: checkDate, trigger: "change" }],
          representation: [
            {
              required: true,
              message: "Người đại diện không được để trống",
              trigger: "change",
            },
          ],
          fatherPhone: [
            {
              min: 10,
              max: 10,
              message: "Số điện thoại bao gồm 10 số",
              trigger: "change",
            },
          ],
          motherPhone: [
            {
              min: 10,
              max: 10,
              message: "Số điện thoại bao gồm 10 số",
              trigger: "change",
            },
          ],
          fatherEmail: [
            {
              type: "email",
              message: "Email không đúng định dạng",
              trigger: ["blur", "change"],
            },
          ],
          motherEmail: [
            {
              type: "email",
              message: "Email không đúng định dạng",
              trigger: ["blur", "change"],
            },
          ],
        },
      },
    };
  },
  created() {
    // this.$store.dispatch('gradeModule/fetchDataGradeOfSchoolList')
  },
  computed: {
    ...mapState('gradeModule', ['gradeOfSchoolList']),
    ...mapGetters('classStore', ['classOfGradeList']),
  },
  methods: {
    ...mapActions('gradeModule', ['fetchDataGradeOfSchoolList']),
    ...mapActions('classStore', ['fetchDataClassOfGradeList']),
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },
    //reset when click x
    closeDialog() {
      this.$refs["formAllTabStudent"].resetFields();
      this.$emit("dialog-close");
      this.handleRemove();
      this.clearTabDefault();
      // Gọi hàm mới để reset dữ liệu kidMainInfo về mặc định
      this.clearKidMainInfo();
    },
    //click when click button
    closeDialogByButton() {
      this.$refs["formAllTabStudent"].resetFields();
      this.$emit("dialog-close");
      this.handleRemove();
      this.clearTabDefault();
      // Gọi hàm mới để reset dữ liệu kidMainInfo về mặc định
      this.clearKidMainInfo();
    },
    /**
     * remove image
     */
    handleRemove() {
      if (this.$refs.upload && this.$refs.upload.clearFiles) {
        this.$refs.upload.clearFiles();
      }
      this.formAllTabStudent.kidMainInfo.avatarKid = "";
      this.showPicutreInitial = false;
      this.showUpload = true;
      this.imageUrl = null;
      this.imageUrlPreview = "";
    },
    handleClickTab(tab) {
      let tabNameClick = tab.name;
      if (tabNameClick == "mainInfo") {
        console.log(tabNameClick);
      } else if (tabNameClick == "extraInfo") {
        this.tabExtraInfoMethod();
      }
    },
    clearTabDefault() {
      setTimeout(() => {
        (this.formAllTabStudent.kidMainInfo.kidStatus = "STUDYING"),
          (this.activeTabName = "mainInfo");
      }, 500);
    },

    // Hàm mới: đặt kidMainInfo về giá trị mặc định
    clearKidMainInfo() {
      this.formAllTabStudent.kidMainInfo = {
        idGrade: "",
        idClass: "",
        kidStatus: "STUDYING",
        fullName: "",
        birthDay: "",
        gender: "",
        nickName: "",
        address: "",
        dateStart: "",
        note: "",
        representation: "",
        fatherName: "",
        fatherBirthday: "",
        fatherPhone: "",
        fatherEmail: "",
        fatherJob: "",
        motherName: "",
        motherBirthday: "",
        motherPhone: "",
        motherEmail: "",
        motherJob: "",
        identificationNumber: "",
        permanentAddress: "",
        ethnic: "",
        taxIdentificationNumber: "",
        accountHolderStudent: "",
        bankNameStudent: "",
        accountNumberStudent: "",
        fatherCitizenIdentification: "",
        motherCitizenIdentification: "",
      };

      // reset thông tin ảnh
      this.imageUrl = "";
      if (this.$refs.upload && this.$refs.upload.clearFiles) {
        this.$refs.upload.clearFiles();
      }
    },

    triggerAvatarUpload() {
      this.$refs.upload.$el.querySelector('.el-upload__input').click();
    },
    /**
     * click change image
     */
    handleChangeUpload(file) {
      try {
        this.beforeAvatarUpload(file);
        this.showPicutreInitial = false;
        this.showUpload = !this.showUpload;
        this.imageUrl = file.raw;
        this.imageUrlPreview = URL.createObjectURL(file.raw);
      } catch (e) {
        console.error(e);
      }
    },

    /**
     * check image before upload
     */
    beforeAvatarUpload(file) {
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isLt5M = file.raw.size / 1024 / 1024 <= 5;
      if (!isJPG && !isPNG) {
        this.$message.error("Bạn phải chọn dạng ảnh");
        this.$refs.upload.clearFiles();
        throw "file not valid";
      }
      if (!isLt5M) {
        this.$message.error("Ảnh không được quá 5MB!");
        this.$refs.upload.clearFiles();
        throw "over size";
      }
    },
    /**
     * create avatar
     */
    async submitAvatar() {
      let formDatas = new FormData();
      if (this.imageUrl != "") {
        formDatas.append("multipartFile", this.imageUrl);
      }
      await StudentService.createAvatar(formDatas)
        .then(() => {
          console.log("ok");
        })
        .catch((err) => {
          console.log(err);
          throw "error create avatar";
        });
    },
    tabParentIconMethod() {
      StudentService.findIconParentCreate()
        .then((resp) => {
          this.parentIconAppCreate.parentIconCreate1 =
            resp.data.data.appIconResponseList1;
          this.parentIconAppCreate.parentIconCreate2 =
            resp.data.data.appIconResponseList2;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    submitForm(fromData) {
      this.$refs[fromData].validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          let iconArray1 = this.parentIconAppCreate.parentIconCreate1;
          let iconArray2 = this.parentIconAppCreate.parentIconCreate2;
          let iconArray = iconArray1.concat(iconArray2);
          this.formAllTabStudent.parentIconApp = iconArray;
          this.formAllTabStudent.kidMainInfo.avatarKid == "";
          let formDataInput = this.formAllTabStudent;
          if (
            (formDataInput.kidMainInfo.representation == "Bố" &&
              (formDataInput.kidMainInfo.fatherPhone == "" ||
                formDataInput.kidMainInfo.fatherName == "")) ||
            (formDataInput.kidMainInfo.representation == "Mẹ" &&
              (formDataInput.kidMainInfo.motherPhone == "" ||
                formDataInput.kidMainInfo.motherName == ""))
          ) {
            this.$confirm(
              `Chưa có họ tên hoặc số điện thoại người đại diện.
              Bạn có chắc chắn muốn tạo học sinh?`,
              "Thông báo!",
              {
                distinguishCancelAndClose: true,
                closeOnClickModal: false,
                confirmButtonText: "Có",
                cancelButtonText: "Không",
              }
            )
              .then(() => {
                this.submitAvatar()
                  .then(() => {
                    this.submitData(formDataInput, fromData);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              })
              .catch(() => {
                this.loadingButton = false;
              });
          } else {
            this.submitAvatar()
              .then(() => {
                this.submitData(formDataInput, fromData);
              })
              .catch((err) => {
                console.log(err);
              });
          }
        } else {
          console.log("error validate data!");
          return false;
        }
      });
    },

    submitData(dataInput, fromDataValidate) {
      StudentService.create(dataInput)
        .then((response) => {
          this.$message({
            message: response.data.message,
            type: "success",
          });
          setTimeout(() => {
            this.closeDialogByButton(fromDataValidate);
            this.showPicutreInitial = false;
          }, 500);
        })
        .catch((err) => {
          this.$message({
            message: err.response.data.message,
            type: "error",
          });
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },
    selectGradeMethod() {
      this.formAllTabStudent.kidMainInfo.idClass = "";
      this.fetchDataClassOfGradeList(this.formAllTabStudent.kidMainInfo.idGrade)
    },

  },
};
</script>
<style>
.hideUpload > div {
  display: none;
}
</style>
<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";

/deep/.el-dialog__title {
  font-size: 25px;
  color: #606266;
}
/deep/.el-dialog__body {
  padding-top: 0;
}

// /deep/.el-tabs__nav {
//   background: #a0a19ce0;
// }
// /deep/.el-tabs__item {
//   color: white;
// }
// /deep/.el-tabs__item.is-active {
//   color: white;
//   background: #67c23a;
// }
/deep/.el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}
/deep/.el-button--primary {
  width: 100%;
  background: #409eff;
}
/deep/.upload-demo {
  text-align: center;
  .el-upload {
    width: 100%;
  }
}
/deep/.el-avatar {
  display: inline;
  img {
    border-radius: 5px;
    width: 100%;
  }
}
/deep/.el-input.is-disabled .el-input__inner {
  text-align: center;
  color: #d13b93;
  font-weight: bold;
}
/deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}
/deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}
/deep/input::-webkit-outer-spin-button,
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.el-select {
  display: block;
}
.table-icon-1 {
  width: 30%;
  margin-left: 15%;
  display: inline-block;
}
.table-icon-2 {
  width: 30%;
  margin-right: 15%;
  float: right;
}

.tab-infor-button {
  text-align: right;
  margin-top: 20px;
}
.bg-purple {
  background: #d3dce6;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.group-radio-status {
  margin: 0 50px;
  .kids-status {
    margin-bottom: 10px;
  }
}

/* Redesigned Information Tab Style rules */
.common-info-tab {
  & > .el-row {
    display: flex;
    align-items: stretch;
  }

  /deep/ .el-form-item {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 16px;
    
    .el-form-item__label {
      width: 100% !important;
      text-align: left;
      float: none;
      line-height: 20px;
      padding: 0 0 6px 0;
      font-size: 13px;
      font-weight: 600;
      color: #475569;
    }
    
    .el-form-item__content {
      margin-left: 0 !important;
      line-height: normal;
    }
  }
}

.profile-sidebar-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.02);
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  box-sizing: border-box;
}

.profile-avatar-wrap {
  position: relative;
  width: 140px;
  height: 140px;
  margin: 0 auto;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #e2e8f0;
  background: #f8fafc;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  
  .profile-avatar {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .avatar-trigger-area {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: #64748b;
    font-size: 12px;
    font-weight: 500;
    gap: 4px;
    transition: all 0.2s ease;

    i {
      font-size: 20px;
      font-weight: bold;
    }

    &:hover {
      background: #f1f5f9;
      color: #3b82f6;
    }
  }

  .avatar-actions-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(15, 23, 42, 0.65);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    opacity: 0;
    transition: opacity 0.25s ease;
    z-index: 10;
  }

  &:hover .avatar-actions-overlay {
    opacity: 1;
  }

  .avatar-action-btn {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: none;
    outline: none;
    background: #ffffff;
    color: #0f172a;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    transition: all 0.2s ease;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    &:hover {
      transform: scale(1.1);
    }

    &.edit-btn:hover {
      background: #3b82f6;
      color: #ffffff;
    }

    &.delete-btn:hover {
      background: #ef4444;
      color: #ffffff;
    }
  }
}

.profile-status-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.section-divider {
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.status-radio-group {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 6px;
  
  /deep/ .el-radio-button {
    width: 100%;
    margin: 0;
    
    .el-radio-button__inner {
      width: 100%;
      border-radius: 10px !important;
      border: 1px solid #e2e8f0;
      box-shadow: none !important;
      padding: 10px 15px;
      font-size: 13px;
      font-weight: 500;
      transition: all 0.2s ease;
      color: #64748b;
    }
    
    &.is-active .el-radio-button__inner {
      background-color: #3b82f6;
      border-color: #3b82f6;
      color: #ffffff;
    }
  }
}

.info-section-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.02);
  margin-bottom: 20px;
  height: 100%;
  box-sizing: border-box;
}

.column-parent-flex {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 20px;
  
  .info-section-card {
    flex: 1;
    margin-bottom: 0;
  }
}

.card-inner-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
  
  i {
    color: #3b82f6;
    font-size: 16px;
  }
}

.parent-card {
  .card-inner-title i {
    color: #10b981;
  }
}

.gender-radio-group {
  width: 100%;
  display: flex;
  
  /deep/ .el-radio-button {
    flex: 1;
    
    .el-radio-button__inner {
      width: 100%;
      border-radius: 10px !important;
      padding: 10px 0;
      text-align: center;
      border: 1px solid #e2e8f0;
      color: #64748b;
      font-weight: 500;
    }
    
    &.is-active .el-radio-button__inner {
      background-color: #3b82f6;
      border-color: #3b82f6;
      color: #ffffff;
    }
  }
}
</style>
